export default __webpack_public_path__ + "static/media/Unwasted-combined-screenshot.873c0ea8.png";